import axios from 'axios';
import RouteUrls from '../common/RouteUrls';
import {getAuthToken, getXSRFToken} from "../common/authTokenUtil";

export const setNewSecretPhrase = async (orgName,userId, newSecretPhrase,deviceSignature) => {
  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.NEW_SET_SECRET_PHRASE,
      headers: {
        'Authorization': `Bearer ${getAuthToken()}`,
        'correlation-id':
          '12345',
        'client-id':
          'PNET',
        'device-id': deviceSignature,
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getXSRFToken()
      },
      data: {
        orgName: orgName,
        userLoginName: userId,
        newSecretPhrase: newSecretPhrase,
        confirmNewSecretPhrase: newSecretPhrase
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error changing password : ', error);
    throw error;
  }
}